<!-- eslint-disable vue/html-self-closing -->
<template>
  <div v-if="projectAlias && userAlias">
    <custom-select
      v-model="selectedModel"
      class="select select-tag"
      :options="options"
      :searchable="true"
      :filterable="false"
      :clearable="clearable"
      :placeholder="placeholder"
      :required="true"
      :error="error"
      :taggable="taggable"
      label="name"
      clear-search-on-select="true"
      @input="onChange"
      @open="onOpen"
      @close="onClose"
      @search="onSearch"
    >
      <template #footer>
        <li v-show="showLoader" ref="load" class="select-tag__loader text-muted">
          Загрузка...
        </li>
      </template>
    </custom-select>
    <input
      name="releaseTagName"
      type="hidden"
      :value="selectedModel?.name ? selectedModel.name : selectedModel"
    />
  </div>
  <div v-else>
    <pacman-loader size="15" style="position: relative !important" />
  </div>
</template>

<script>
import RepoS from "@shared/services/repository.service";
import sharedComponentsMessages from "@shared/shared-components/sharedComponentsMessages";
import PacmanLoader from "@shared/shared-components/shared/packman-loader";
// eslint-disable-next-line import/no-unresolved
import CustomSelect from "./custom-select";

export default {
  name: "ProjectTagSelector",
  components: { PacmanLoader, CustomSelect },
  props: {
    projectAlias: { default: null },
    userAlias: { default: null },
    selected: { default: null },
    redirect: {
      type: Boolean,
      default: false,
    },
    error: { default: null },
    placeholder: {
      default: function () {
        return this.$t('select_tag');
      },
    },
    clearable: { default: null },
    taggable: { default: null }
  },

  data() {
    return {
      options: [],
      selectedModel: null,
      pages: [],
      observer: null,
      nextPage: 1,
      showLoader: true,
    };
  },
  computed: {
    hasNextPage() {
      return this.nextPage < this.pages.totalPages;
    },
  },
  mounted() {
    this.selectedModel = this.selected;
    this.observer = new IntersectionObserver(this.infiniteScroll);
  },
  methods: {
    getOptions(callback) {
      RepoS.getProjectTags(this.projectAlias, this.userAlias, {
        page: this.nextPage,
      }).then((res) => {
        this.options.push(...res.items);
        this.pages = res.page;
        this.nextPage = this.pages.number + 1;
        if (callback) {
          callback();
        }
      });
    },
    onChange(e) {
      this.$emit("input", e);
      if (!this.redirect) return;
      const params = new URLSearchParams(window.location.search);
      params.set("tag", e.id);
      window.location.search = params.toString();
    },
    async onOpen() {
      await this.$nextTick();

      RepoS.getProjectTags(this.projectAlias, this.userAlias, {}, false).then((res) => {
        this.options = res.items;
        this.pages = res.page;
        this.observer.observe(this.$refs.load);
      });
    },
    onClose() {
      this.observer.disconnect();
      this.setDefault();
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent;
        const { scrollTop } = ul;

        const setScroll = () => {
          this.$nextTick(() => {
            ul.scrollTop = scrollTop;
          });
        };

        if (this.hasNextPage) {
          this.getOptions(setScroll);
        } else {
          this.showLoader = false;
        }
      }
    },
    onSearch(q) {
      if (q) {
        setTimeout(() => {
          this.observer.disconnect();
          RepoS.getProjectTags(this.projectAlias, this.userAlias, { q }, false).then(
            (res) => {
              this.options = res.items;
              this.showLoader = false;
            }
          );
        }, 500);
      }
    },
    setDefault() {
      this.nextPage = 1;
      this.options = [];
      this.showLoader = true;
      this.observer.disconnect();
    },
  },
  i18n: {
    messages: sharedComponentsMessages,
  },
};
</script>

<style lang="scss" scoped>
.select-tag {
  $this: ".select-tag";
  //--vs-dropdown-min-width: min-content;

  #{$this}__loader {
    text-align: center;
  }
}
</style>
